// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1C6Cd","modalForm":"UpgradeEpcsModal_modalForm__2Wplw","modalFooter":"UpgradeEpcsModal_modalFooter__Zj3VI"};